import React, { createContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [authLoading, setAuthLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      setUser({ token });
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    setAuthLoading(true);
    setError(null);

    try {
      const response = await fetch(
        "https://netmax-play-api.vercel.app/api/v1/client-login",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email, password }),
        }
      );

      const result = await response.json();

      if (!response.ok || !result.token) {
        setError("Credenciales inválidas");
        setAuthLoading(false);
        return false;
      }

      localStorage.setItem("token", result.token);
      localStorage.setItem("userSession", JSON.stringify(result));
      setUser({ token: result.token });
      setAuthLoading(false);
      navigate("/home");
      return true;
    } catch (error) {
      setError(error.message || "Ocurrió un error inesperado");
      setAuthLoading(false);
      return false;
    }
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userSession");
    setUser(null);
    navigate("/login");
  };

  return (
    <AuthContext.Provider
      value={{ user, login, logout, loading, authLoading, error, setError }}
    >
      {!loading ? (
        children
      ) : (
        <div className="flex flex-col items-center justify-center mt-10 text-white">
          <div className="animate-spin text-white text-4xl mb-2">🔄</div>
          <div>Cargando...</div>
        </div>
      )}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
